<div class="page-size">
  <span>Rows per page:</span>
  <mat-form-field>
    <mat-label></mat-label>
    <mat-select [value]="pageSize" (selectionChange)="onPageSizeChange($event)">
      @for (option of pageSizeOptions; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<span class="page-count">{{ pageCount }}</span>
<div class="pages-view">
  <button
    type="button"
    title="First Page"
    [disabled]="pageIndex === 0"
    (click)="goToPage('first')"
  ></button>
  <button
    type="button"
    title="Previous Page"
    [disabled]="pageIndex === 0"
    (click)="goToPage('previous')"
  ></button>
  <span>{{ pagesView }}</span>
  <button
    type="button"
    title="Next Page"
    [disabled]="pageIndex >= totalPages - 1"
    (click)="goToPage('next')"
  ></button>
  <button
    type="button"
    title="Last Page"
    [disabled]="pageIndex >= totalPages - 1"
    (click)="goToPage('last')"
  ></button>
</div>
